<template>
    <v-form v-model="formData.isValid">
        <template v-if="isCompensationPossible">
            <v-row>
                <v-col cols="12" align="center">
                    <v-alert prominent color="secondary">
                        <h2 class="white--text">Du hast vermutlich Anspruch auf</h2>
                        <br/>
                        <h2 class="white--text">{{compensationResult.compensation}} Euro</h2>
                        <br/>
                        <h2 class="white--text">Schadensersatz pro Reisenden</h2>
                    </v-alert>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12">
                    <p>Bitte wähl wie Du uns beauftragen möchtest</p>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" v-if="showRSVFulfillmentOption">
                    <v-card outlined>
                        <v-card-title>Rechtsschutzversicherung kontaktieren</v-card-title>
                        <v-card-text>
                            Wähle 'Klage mit Rechtsschutz' für eine kompetente Durchsetzung deiner Rechte mit Unterstützung deiner Rechtsschutzversicherung.
                            Du bekommst die volle Entschädigung und übernimmst lediglich die Selbstbeteiligung,
                            die dir bei einem erfolgreichen Ausgang vollständig zurückerstattet wird.
                            Die Deckungsanfrage bei deiner Versicherung übernehmen wir für dich – völlig kostenfrei.
                        </v-card-text>
                        <v-divider/>
                        <v-card-actions>
                            <v-checkbox color="primary" label="Wählen" v-model="viewData.isRSVSelected" :rules="[isFulfillmentSelectionValid]"/>
                            <v-spacer/>
                            <v-btn rounded color="secondary" outlined @click.stop="openRSVDetails">
                                Weitere Informationen
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-col>
                <v-col cols="12" v-if="showImmediateFulfillmentOption">
                    <v-card outlined>
                        <v-card-title>Sofortgeld</v-card-title>
                        <v-card-text>
                            Sichere dir sofort 40% deiner Ansprüche durch unseren Forderungskauf.
                            Wir übernehmen den ganzen Prozess und dein Risiko.
                            Du erhältst binnen weniger Tage 40% deiner Entschädigung – ganz unabhängig vom Erfolg unserer Tätigkeit.
                        </v-card-text>
                        <v-divider/>
                        <v-card-actions>
                            <v-checkbox color="primary" label="Wählen" v-model="viewData.isImmediatelySelected" :rules="[isFulfillmentSelectionValid]"/>
                            <v-spacer/>
                            <v-btn rounded color="secondary" outlined @click.stop="openImmediateDetails">
                                Weitere Informationen
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-col>
                <v-col cols="12" v-if="showCommissionFulfillmentOption">
                    <v-card outlined>
                        <v-card-title>Provision</v-card-title>
                        <v-card-text>
                            Mit unserer Inkassolösung, die ähnlich funktioniert, wie bei bekannten Fluggasthelfern wie z.B. Flightright,
                            übernehmen wir die die Einforderung deiner Entschädigung für dich.
                            Im Erfolgsfall erhalten wir 30% deiner Entschädigung, während du den Großteil behältst.
                            Sollten wir keinen Erfolg haben – fallen auch keine Kosten für dich an.
                        </v-card-text>
                        <v-divider/>
                        <v-card-actions>
                            <v-checkbox color="primary" label="Wählen" v-model="viewData.isCommissionSelected" :rules="[isFulfillmentSelectionValid]"/>
                            <v-spacer/>
                            <v-btn rounded color="secondary" outlined @click.stop="openCommissionDetails">
                                Weitere Informationen
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-col>
                <v-col cols="12">
                    <v-card outlined>
                        <v-card-title>Sue it yourself</v-card-title>
                        <v-card-text>
                            Nutze unseren kostenlosen Musterschreiben-Generator, um selbstständig deine Entschädigung einzufordern.
                            Dabei behältst du 100% der Entschädigung für dich.
                        </v-card-text>
                        <v-divider/>
                        <v-card-actions>
                            <v-checkbox color="primary" label="Wählen" v-model="viewData.isSelfSelected" :rules="[isFulfillmentSelectionValid]"/>
                            <v-spacer/>
                            <v-btn rounded color="secondary" outlined @click.stop="openSelfDetails">
                                Weitere Informationen
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-col>
                <v-col cols="12" v-if="showFeeFulfillmentOption">
                    <v-card outlined>
                        <v-card-title>Honorar</v-card-title>
                        <v-card-text>
                            Wähle 'Anwaltsbrief' für eine außergerichtliche Lösung mit professionellem Anwaltsschreiben für nur 50€.
                            Wir setzen uns für deine Entschädigung ein, ohne Gerichtsverfahren.
                        </v-card-text>
                        <v-divider/>
                        <v-card-actions>
                            <v-checkbox color="primary" label="Wählen" v-model="viewData.isFeeSelected" :rules="[isFulfillmentSelectionValid]"/>
                            <v-spacer/>
                            <v-btn rounded color="secondary" outlined @click.stop="openFeeDetails">
                                Weitere Informationen
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-col>
            </v-row>
        </template>
        <template v-else>
            <v-row>
                <v-col cols="12" align="center">
                    <v-alert prominent color="error">
                        <h2 class="white--text">{{noCompensationReason.text}}</h2>
                    </v-alert>
                </v-col>
            </v-row>
        </template>
        <v-dialog v-model="viewData.showDetailsDialog" persistent max-width="600px">
            <v-toolbar>
                <v-toolbar-title>{{detailsDialogTitle}}</v-toolbar-title>
                <v-spacer/>
                <v-toolbar-items>
                    <v-btn class="mb-6" icon small @click.stop="closeDetailsDialog">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar-items>
            </v-toolbar>
            <v-card tile>
                <v-card-text>
                    {{ detailsDialogText }}
                </v-card-text>
            </v-card>
        </v-dialog>
    </v-form>
</template>

<script>
import FulfillmentMethods from "@/constants/FulfillmentMethods";
import CompensationScenarios from "@/constants/CompensationScenarios";

export default {
    props: {
        compensationResult: {
            type: Object,
            default: function ()
            {
                return {
                    compensation: null,
                    scenario: null
                };
            }
        },
        hasRSV: {
            type: String
        },
        flightData: {
            type: Object,
            default: function()
            {
                return {
                    main_airline_id: null
                }
            }
        },
        airlines: {
            type: Array,
            default: function()
            {
                return [];
            }
        }
    },
    emits: ['validity-changed', 'form-data-changed'],
    computed: {
        isFulfillmentSelectionValid()
        {
            if(this.selectedFulfillmentMethod === null)
                return 'Bitte wähle eine Beauftragungsmethode aus';

            return true;
        },
        isCompensationPossible()
        {
            return this.compensationResult.scenario === CompensationScenarios.COMPENSABLE.value;
        },
        noCompensationReason()
        {
            if(this.compensationResult.scenario === null)
            {
                return {
                    value: null,
                    text: null
                };
            }

            return CompensationScenarios.toArray().find((reason) => reason.value === this.compensationResult.scenario);
        },
        detailsDialogTitle()
        {
            let title = 'Beauftragungsmethode: ';

            switch(this.viewData.detailsDialogVariant)
            {
                case FulfillmentMethods.FEE.value:
                    title += FulfillmentMethods.FEE.title;
                    break;
                case FulfillmentMethods.COMMISSION.value:
                    title += FulfillmentMethods.COMMISSION.title;
                    break;
                case FulfillmentMethods.SELF.value:
                    title += FulfillmentMethods.SELF.title;
                    break;
                case FulfillmentMethods.RSV.value:
                    title += FulfillmentMethods.RSV.title;
                    break;
                case FulfillmentMethods.IMMEDIATELY.value:
                    title += FulfillmentMethods.IMMEDIATELY.title;
                    break;
            }

            return title;
        },
        detailsDialogText()
        {
            switch(this.viewData.detailsDialogVariant)
            {
                case FulfillmentMethods.FEE.value:
                    return 'Sollte der Musterbrief / Anwaltsbrief nicht die gewünschte Wirkung zeigen, und sich die Fluggesellschaft weigern, deine Ansprüchen anzuerkennen, stehen dir weiterhin unseren anderen Lösungsoptionen offen.'
                case FulfillmentMethods.COMMISSION.value:
                    return 'Wenns läuft, bezahlst du uns';
                case FulfillmentMethods.SELF.value:
                    return 'Sollte der Musterbrief / Anwaltsbrief nicht die gewünschte Wirkung zeigen, und sich die Fluggesellschaft weigern, deine Ansprüchen anzuerkennen, stehen dir weiterhin unseren anderen Lösungsoptionen offen.';
                case FulfillmentMethods.RSV.value:
                    return 'Rechtsschutzversicherung wird sich freuen...';
                case FulfillmentMethods.IMMEDIATELY.value:
                    return 'Sofort geld, super cool';
                default:
                    return '';
            }
        },
        selectedAirline()
        {
            if(this.flightData.main_airline_id !== null)
                return this.getAirlineById(this.flightData.main_airline_id);

            return {
                is_rsv_payment_accepted: false,
                is_immediatley_payable: false,
                is_fee_accepted: false,
                is_commission_accepted: false
            }
        },
        showRSVFulfillmentOption()
        {
            return (this.hasRSV === '1' && this.selectedAirline.is_rsv_payment_accepted);
        },
        showImmediateFulfillmentOption()
        {
            return this.selectedAirline.is_immediatley_payable;
        },
        showFeeFulfillmentOption()
        {
            return this.selectedAirline.is_fee_accepted;
        },
        showCommissionFulfillmentOption()
        {
            return this.selectedAirline.is_commission_accepted;
        }
    },
    data: () => ({
        formData:
        {
            isValid: false,
        },
        viewData:
        {
            isFeeSelected: false,
            isSelfSelected: false,
            isRSVSelected: false,
            isImmediatelySelected: false,
            isCommissionSelected: false,
            showDetailsDialog: false,
            detailsDialogVariant: null
        },
        selectedFulfillmentMethod: null
    }),
    methods: {
        resetFormValidity()
        {
            let checkedCount = 0;

            if (this.viewData.isFeeSelected)
                checkedCount++;

            if (this.viewData.isSelfSelected)
                checkedCount++;

            if (this.viewData.isRSVSelected)
                checkedCount++;

            if (this.viewData.isImmediatelySelected)
                checkedCount++;

            if (this.viewData.isCommissionSelected)
                checkedCount++;

            if (checkedCount === 1)
                this.formData.isValid = true;
            else
            {
                this.formData.isValid = false;
                this.selectedFulfillmentMethod = null;
            }
        },
        showDetailsDialog(variant)
        {
            this.viewData.detailsDialogVariant = variant;
            this.viewData.showDetailsDialog = true;
        },
        closeDetailsDialog()
        {
            this.viewData.showDetailsDialog = false;
            this.viewData.detailsDialogVariant = null;
        },
        openFeeDetails()
        {
            this.showDetailsDialog(FulfillmentMethods.FEE.value);
        },
        openSelfDetails()
        {
            this.showDetailsDialog(FulfillmentMethods.SELF.value);
        },
        openRSVDetails()
        {
            this.showDetailsDialog(FulfillmentMethods.RSV.value);
        },
        openImmediateDetails()
        {
            this.showDetailsDialog(FulfillmentMethods.IMMEDIATELY.value);
        },
        openCommissionDetails()
        {
            this.showDetailsDialog(FulfillmentMethods.COMMISSION.value);
        },
        getAirlineById(id)
        {
            return this.airlines.find((airline) => airline.id === id);
        }
    },
    watch: {
        'viewData.isFeeSelected': function (newValue)
        {
            if (newValue)
            {
                this.viewData.isSelfSelected = false;
                this.viewData.isRSVSelected = false;
                this.viewData.isImmediatelySelected = false;
                this.viewData.isCommissionSelected = false;

                this.selectedFulfillmentMethod = FulfillmentMethods.FEE.value;
            }

            this.resetFormValidity();
        },
        'viewData.isSelfSelected': function (newValue)
        {
            if (newValue)
            {
                this.viewData.isFeeSelected = false;
                this.viewData.isRSVSelected = false;
                this.viewData.isImmediatelySelected = false;
                this.viewData.isCommissionSelected = false;

                this.selectedFulfillmentMethod = FulfillmentMethods.SELF.value;
            }

            this.resetFormValidity();
        },
        'viewData.isRSVSelected': function (newValue)
        {
            if (newValue)
            {
                this.viewData.isFeeSelected = false;
                this.viewData.isSelfSelected = false;
                this.viewData.isImmediatelySelected = false;
                this.viewData.isCommissionSelected = false;

                this.selectedFulfillmentMethod = FulfillmentMethods.RSV.value;
            }

            this.resetFormValidity();
        },
        'viewData.isImmediatelySelected': function (newValue)
        {
            if (newValue)
            {
                this.viewData.isFeeSelected = false;
                this.viewData.isSelfSelected = false;
                this.viewData.isRSVSelected = false;
                this.viewData.isCommissionSelected = false;

                this.selectedFulfillmentMethod = FulfillmentMethods.IMMEDIATELY.value;
            }

            this.resetFormValidity();
        },
        'viewData.isCommissionSelected': function (newValue)
        {
            if (newValue)
            {
                this.viewData.isFeeSelected = false;
                this.viewData.isSelfSelected = false;
                this.viewData.isRSVSelected = false;
                this.viewData.isImmediatelySelected = false;

                this.selectedFulfillmentMethod = FulfillmentMethods.COMMISSION.value;
            }

            this.resetFormValidity();
        },
        'formData.isValid': function(newValue)
        {
            this.$emit('validity-changed', newValue);
        },
        selectedFulfillmentMethod: function(newValue)
        {
            this.$emit('form-data-changed', newValue);
        }
    }
}
</script>

<style scoped>

</style>
